import { createApp } from 'vue';
import { clerkPlugin } from '@clerk/vue';
import App from './App.vue';
import router from './router';
import pinia from './stores';
import i18n from './i18n';
import './styles/main.css';

const ENV = import.meta.env.VITE_APP_ENV || 'development';

const PUBLISHABLE_KEY_MAP: Record<string, string | undefined> = {
  development: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY_DEV,
  pre: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY_PRE,
  production: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY_PRO,
};

const PUBLISHABLE_KEY = PUBLISHABLE_KEY_MAP[ENV];

if (!PUBLISHABLE_KEY) {
  throw new Error(`Missing VITE_CLERK_PUBLISHABLE_KEY for environment: ${ENV}`);
}

const app = createApp(App);

app.use(clerkPlugin, {
  publishableKey: PUBLISHABLE_KEY,
});
app.use(pinia);
app.use(i18n);
app.use(router);

app.mount('#app');
